import client from './client';

export const modulesApi = {
  getAll: () =>
    client.get('/modules'),

  toggle: (key, enabled) =>
    client.put(`/modules/${key}`, { enabled }),

  applyPreset: (preset) =>
    client.post('/modules/preset', { preset }),
};
